module.exports = __webpack_public_path__ + "img/SDLRSAT.dbaa1a8c.svg";